// extracted by mini-css-extract-plugin
export var infoRow = "_uf-2";
export var labelContainer = "_uf-0";
export var rightInfo = "_uf-1";